<template>
  <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" nudge-top="24" offset-y min-width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field :label="label" :class="small?'text-body-2':''" readonly v-on="on" v-model="dateFormatted" hide-details dense
                    append-icon="mdi-menu-down" @click:append="timeChange=false;dateMenu=true"
                    >
      </v-text-field>
    </template>
    <v-card>
      <v-container class="pa-0">
        <v-row no-gutters>
          <v-col>
            <v-date-picker v-model="date" no-title :type="monthOnly?'month':'date'" @input="change"/>
          </v-col>
        </v-row>
        <v-row no-gutters class="pb-2" v-if="!dateOnly">
          <v-col align="center">
            <v-menu offset-y max-height="60vh">
              <template v-slot:activator="{on}">
                <v-btn outlined v-on="on" class="hour-min text-caption">
                  {{hour}}
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list dense class="text-caption">
                <v-list-item v-for="hr in 12" :key="hr" class="pr-0 pl-2" @click="hour = hr === 1 ? 12 : hr - 1;timeChange=true,dateFormat()">
                  {{ hr === 1 ? 12 : hr - 1 }}
                 </v-list-item>
              </v-list>
            </v-menu>
            :
            <v-menu offset-y max-height="60vh">
              <template v-slot:activator="{on}">
                <v-btn outlined v-on="on" class="hour-min text-caption">
                  {{minute < 10 ? '0' : ''}}{{minute}}
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list dense class="text-caption">
                <v-list-item v-for="min in 60" :key="min" class="pr-0 pl-2" @click="minute = min-1; timeChange=true; dateFormat()">
                  {{min < 11 ? '0' : ''}}{{min-1}}
                 </v-list-item>
              </v-list>
            </v-menu>
            <v-btn-toggle v-model="isAm" class="ampm" mandatory @change="timeChange=true;dateFormat()">
              <v-btn :value="true" class="text-caption text-lowercase">am</v-btn>
              <v-btn :value="false" class="text-caption text-lowercase">pm</v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<style scoped>
.hour-min {
  width: 40px;
  min-width: 40px !important;
  height: 32px !important;
}
.hour-min .v-btn__content i.v-icon {
  margin-left: -4px;
}
.ampm {
  margin-left:8px;
}
.ampm .v-btn.v-size--default {
  width: 36px;
  min-width: 36px !important;
  height: 32px !important;
  padding-left: 0;
  padding-right: 0;
}
</style>

<script>
import {format} from 'date-fns'

export default {
  name: 'DatePickerView',
	props: {
		value: {type:String,required:false},
		label: {type:String,required:false,default:'Date/time'},
		disabled: {type:Boolean,required:false, default:false},
    small: {type:Boolean,required:false, default:false},
    persistentHint: {type:Boolean,required:false,default:false},
    hint: {type:String,required:false},
    outlined: {type:Boolean,required:false, default:true},
    dense: {type:Boolean,require:false,default:true},
    close: {type:Boolean,require:false,default:false},
    hideDetails: {type:Boolean,required:false},
    dateOnly: {type:Boolean,required:false,default:false},
    monthOnly: {type:Boolean,required:false,default:false}
  },
  data() {
    return {
      dateMenu: false,
      date: this.value,
      dateFormatted: '',
      hour: 12,
      minute: 0,
      isAm: false,
      timeChange: false
    }
  },
  created() {
    this.formatDate();

  },
  watch: {
    value() {
      this.formatDate();
    },
    dateMenu() {
      if (!this.dateMenu && this.timeChange)
        this.setChange();
    }
  },
  methods: {
    formatDate() {
      const dateFormat = 'yyyy-MM-dd';
      if (this.dateOnly) {
        this.date = this.value;
        if (!this.date)     // not set yet... wait for watch
          return;
        const dp = this.date.split('-');
        this.dateFormatted = format(new Date(dp[0],dp[1]-1,dp[2]||1), dateFormat);
      }
      else {
        this.date = this.value.substring(0, 10);
        const d = this.value.substring(10).split(':');
        this.hour = parseInt(d[0]);
        this.isAm = this.hour < 12;
        if (this.hour === 0)
          this.hour = 12;
        else if (this.hour > 12)
          this.hour -= 12;
        this.minute = parseInt(d[1]);
      }
    },
		change() {
      this.timeChange = false;    // To prevent second notification
      this.dateMenu = false;
      this.setChange();
		},
    setChange() {
      let returnDate;
      if (this.monthOnly)
        returnDate = this.date.substring(0,7);
      else if (this.dateOnly)
        returnDate = this.date;
      else {
        const h = (this.hour === 12 ? 0 : this.hour) + (this.isAm ? 0 : 12);
        returnDate = `${this.date} ${h<10?'0':''}${h}:${this.minute<10?'0':''}${this.minute}:00`;
      }
			this.$emit('input', returnDate);
			this.$emit('change', returnDate);
    }
  }
}
</script>